"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeroIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("@site/utils");
var _HeroIcon = require("./styles/HeroIcon");
const HeroIcon = ({
  height,
  width,
  border = false,
  customImage
}) => {
  const SMALL_LIMIT = 42;
  const defaultImage = `${(0, _utils.getImagesBaseUrl)()}dbs/sales_rep_hero.png`;
  const customImageUrl = customImage ? `${(0, _utils.getImagesBaseUrl)()}dbs/${customImage}` : null;
  const onImageError = e => {
    e.target.src = defaultImage;
  };
  return /*#__PURE__*/_react.default.createElement(_HeroIcon.HeroIconDiv, {
    "data-testid": "hero-icon-img"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('rounded-radius', {
      'gradient-border': border && height > SMALL_LIMIT && width > SMALL_LIMIT,
      'gradient-border-sm': border && height === SMALL_LIMIT && width === SMALL_LIMIT
    })
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: "sales rep hero icon",
    className: "hero-icon rounded-radius",
    height: height,
    width: width,
    src: customImageUrl || defaultImage,
    onError: onImageError
  })));
};
exports.HeroIcon = HeroIcon;
HeroIcon.propTypes = {
  height: _propTypes.default.number,
  width: _propTypes.default.number,
  border: _propTypes.default.bool,
  customImage: _propTypes.default.string
};